import { Injectable } from '@angular/core';

import { isObservable, Observable, Observer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { LoadingBehaviorSubject } from '../../helpers/loading-behavior-subject.helper';

@Injectable()
export abstract class AbstractActionCreator {
    protected wrapLabelWhenLoadingStream(
        loading$: LoadingBehaviorSubject,
        label: string | Observable<string>
    ): Observable<string> {
        if (isObservable(label)) {
            return label.pipe(switchMap(value => this.wrapLabelWhenLoadingStream(loading$, value)));
        } else {
            return this.switchLabelWhenLoading(loading$, label, `${label}...`);
        }
    }

    protected switchLabelWhenLoading(
        loading$: LoadingBehaviorSubject,
        label: string,
        loadingLabel: string
    ): Observable<string> {
        return loading$.pipe(map(isLoading => (isLoading ? loadingLabel : label)));
    }

    protected mergeObservers(...observers: Observer<any>[]): Observer<any> {
        return {
            complete: () => observers.forEach(observer => observer.complete()),
            error: _ => observers.forEach(observer => observer.error(_)),
            next: _ => observers.forEach(observer => observer.next(_))
        };
    }

    protected disableBasedOnLoader(loader$: Observable<boolean>): Observable<boolean> {
        return loader$.pipe(map(isLoading => !isLoading));
    }
}
